import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import Vuelidate from 'vuelidate'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = true

new Vue({
  store,
  router,
  vuetify,
  Vuelidate,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueClipboard)